export default __webpack_public_path__ + "static/media/DoneIcon.05272aff.svg";